import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import classes from './CodeEditorModeWarningBanner.module.scss';

export const CodeEditorModeWarningBanner = () => (
  <p className={classes.helperText}>
    <InfoOutlinedIcon className={classes.helperIcon} fontSize="inherit" />
    <span>
      Advanced Mode lets you set any property supported by the Nexla API, including properties not
      exposed in the form. Check the{' '}
      <a
        href="https://docs.nexla.com/reference"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.helperLink}
      >
        Nexla API reference
      </a>{' '}
      for the full set of supported properties for this connector.
    </span>
  </p>
);
